import { RESET } from "../constants/type";

const resetAction = () => {
  return function (dispatch) {
    dispatch({ type: RESET });
  };
};
export default resetAction;
